import { render, staticRenderFns } from "./CompanyUsers.vue?vue&type=template&id=3628ce21&scoped=true"
import script from "./CompanyUsers.vue?vue&type=script&lang=js"
export * from "./CompanyUsers.vue?vue&type=script&lang=js"
import style0 from "./CompanyUsers.vue?vue&type=style&index=0&id=3628ce21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628ce21",
  null
  
)

export default component.exports